import React from 'react';
import { TextInput, View } from 'react-native';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';

import type { WizardInputProps } from '@components/tenantStatus/onboardingWizard/types';

const MULTILINE_MIN_HEIGHT = 80;

const WizardInput = ({
  C,
  value,
  onChangeText,
  placeholder,
  multiline,
  maxLength,
  testID,
  keyboardType,
  autoCapitalize,
  containerStyle,
}: WizardInputProps) => (
  <View
    style={[
      {
        borderWidth: 1,
        borderColor: C('Hairline/Light/No trans [mobile]'),
        borderRadius: scale(8),
        paddingHorizontal: scale(12),
        paddingVertical: scale(10),
      },
      containerStyle,
    ]}
  >
    <TextInput
      value={value}
      onChangeText={onChangeText}
      placeholder={placeholder}
      placeholderTextColor={C('Label/Light/Tertiary')}
      multiline={multiline}
      maxLength={maxLength}
      keyboardType={keyboardType}
      autoCapitalize={autoCapitalize}
      testID={testID}
      style={[
        font['Subhead 2'],
        {
          color: C('Label/Light/Primary'),
          padding: 0,
          // RN-web: suppress browser's :focus outline (outlineWidth alone doesn't on Safari).
          outlineStyle: 'none',
          outlineWidth: 0,
          ...(multiline && { minHeight: scale(MULTILINE_MIN_HEIGHT), textAlignVertical: 'top' as const }),
        },
      ]}
    />
  </View>
);

export default WizardInput;
